import React, { useState, useEffect } from "react";

import "../css/PopupEmail.css";

import InputData from "../../components/InputData";
import InputTextClausulas from "../../support/components/InputTextClausulas";
import ButtonIconH from "../../components/ButtonIconH";
import PopupEmailAttached from "./PopupEmailAttached";
import LoadingScreen from "../../components/LoadingScreen";
import { checkFormat } from "../../js/format";
import { post } from "../../js/post";
import { userData, selectedOptic } from "../../js/utils";

export default ({
  show,
  destinatario = "",
  asunto: asuntoInicial = "",
  adjuntos = [],
  onCancel,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [ready, setReady] = useState(false);
  const [sending, setSending] = useState(false);
  const [remitente, setRemitente] = useState("");
  const [para, setPara] = useState("");
  const [asunto, setAsunto] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [adjuntosList, setAdjuntosList] = useState([]);

  const cancel = () => {
    onCancel();
  };

  const removeAdjunto = (index) => {
    createPopupQuestion(
      "¿Desea eliminar el archivo adjunto?",
      () => {
        setAdjuntosList(adjuntosList.filter((_, i) => i !== index));
        removePopupQuestion();
      },
      () => {
        removePopupQuestion();
      },
      "Eliminar",
      "Cancelar",
    );
  };

  const enviar = async () => {
    const emails = para
      .split(/[,;]+/)
      .map((e) => e.trim())
      .filter(Boolean);

    if (
      emails.length === 0 ||
      emails.some((e) => !checkFormat(e, "type-email"))
    ) {
      createPopupQuestion(
        "Correo electrónico inválido.",
        () => {
          removePopupQuestion();
        },
        null,
        "Cerrar",
      );
      return;
    }

    setSending(true);
    const response = await post("EnviarEmail.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      para: emails.join(","),
      asunto,
      adjuntos: adjuntosList.map((adjunto) => ({
        file: (adjunto.fichero ?? "").split(",").pop(),
        fileName: adjunto.titulo,
      })),
      mensaje,
    });
    setSending(false);

    const success = (response?.error ?? "") === "";
    createPopupQuestion(
      success ? "Email enviado correctamente." : response.error,
      () => {
        removePopupQuestion();
        if (success) {
          onCancel();
        }
      },
      null,
      "Entendido",
    );
  };

  useEffect(() => {
    if (!show) {
      setReady(false);
      return;
    }

    (async () => {
      const config = await post("ObtenerConfiguracionOpticaEmail.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
      });

      if (!config?.configurado) {
        onCancel();
        createPopupQuestion(
          "El servidor de correo de esta óptica no ha sido configurado.",
          removePopupQuestion,
          null,
          "Entendido",
        );
        return;
      }

      setRemitente(
        `${config.usuario ?? ""} (${config.de ?? ""})`.toUpperCase(),
      );
      setPara(destinatario.toUpperCase());
      setAsunto(asuntoInicial.toUpperCase());
      setAdjuntosList(adjuntos);
      setMensaje(
        config.pie
          ? "<p><br></p><p><br></p>" +
              config.pie
                .split("\n")
                .map((line) => `<p>${line}</p>`)
                .join("")
          : "",
      );
      setReady(true);

      setTimeout(() => {
        const editor = document.querySelector(
          "#popup-email-mensaje .ql-editor",
        );
        if (editor) {
          editor.focus();
          const range = document.createRange();
          const selection = window.getSelection();
          range.setStart(editor, 0);
          range.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }, 0);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return show && ready ? (
    <div className="popup-container popup-normal popup-email">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Enviar email</div>
          <img
            src="/images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={cancel}
          />
        </div>
        <div className="popup-body">
          <div className="popup-body-email">
            {sending && <LoadingScreen message="" />}
            <div className="popup-email-contenido-element">
              <div className="label popup-email-label">De</div>
              <InputData
                id="popup-email-de"
                size={0}
                input={remitente}
                onChange={null}
                inactive={true}
              />
            </div>
            <div className="popup-email-contenido-element">
              <div className="label popup-email-label">Para</div>
              <InputData
                id="popup-email-para"
                tabIndex={1}
                size={0}
                maxLength={300}
                input={para}
                onChange={(value) => setPara(value.toUpperCase())}
              />
            </div>
            <div className="popup-email-contenido-element">
              <div className="label popup-email-label">Asunto</div>
              <InputData
                id="popup-email-asunto"
                tabIndex={2}
                size={0}
                maxLength={200}
                input={asunto}
                onChange={(value) => setAsunto(value.toUpperCase())}
              />
            </div>
            {adjuntosList.length > 0 && (
              <div className="popup-email-contenido-element">
                <div className="label popup-email-label">Adjuntos</div>
                <div className="popup-email-adjuntos-list">
                  {adjuntosList.map((adjunto, index) => (
                    <PopupEmailAttached
                      key={index}
                      titulo={adjunto.titulo}
                      fichero={adjunto.fichero}
                      onRemove={() => removeAdjunto(index)}
                    />
                  ))}
                </div>
              </div>
            )}
            <div className="popup-email-contenido-element">
              <div className="label popup-email-label">Mensaje</div>
              <InputTextClausulas
                id="popup-email-mensaje"
                extra="popup-email-mensaje-textarea"
                tabIndex={3}
                input={mensaje}
                onChange={setMensaje}
              />
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-row-buttons">
            <ButtonIconH text="Enviar" disabled={sending} onClick={enviar} />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
